import { render } from "./PublicAcademyEnquiryView.vue?vue&type=template&id=475aaf9c&scoped=true&ts=true"
import script from "./PublicAcademyEnquiryView.vue?vue&type=script&lang=ts"
export * from "./PublicAcademyEnquiryView.vue?vue&type=script&lang=ts"

import "./PublicAcademyEnquiryView.vue?vue&type=style&index=0&id=475aaf9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475aaf9c"]])

export default __exports__